module.exports = __webpack_public_path__ + "static/media/rod-swimming.7e92edb9.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rod-swimming.gif
// module id = 183
// module chunks = 0